import useToast from '@hooks/ui/useToast';

function useCopyShopAddress(address?: string) {
  const toast = useToast();
  return () => {
    if (window.navigator.clipboard) {
      window.navigator.clipboard.writeText(address || '')
        .then(() => {
          toast.success('주소가 복사되었습니다.');
        }).catch(() => {
          toast.error('해당 기능이 지원되지 않는 기기입니다.');
        });
    } else {
      toast.error('해당 기능이 지원되지 않는 기기입니다.');
    }
  };
}

export default useCopyShopAddress;
